import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { uniqBy } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { CreateFormService, FrameMotionTransition } from '../create-hallpass-forms/create-form.service';
import { States } from '../create-hallpass-forms/main-hallpass--form/locations-group-container/locations-group-container.component';
import { Navigation } from '../create-hallpass-forms/main-hallpass--form/main-hall-pass-form.component';
import { HallPass } from '../models/HallPass';
import { User } from '../models/User';

@Component({
	selector: 'app-teacher-selection',
	templateUrl: './teacher-selection.component.html',
	styleUrls: ['./teacher-selection.component.scss'],
})
export class TeacherSelectionComponent implements OnInit {
	@Input() pass!: HallPass;

	formState!: Navigation;
	frameMotion$!: BehaviorSubject<FrameMotionTransition>;

	shadow = true;

	headerTransition = {
		'rest-tar-header': true,
		'rest-tar-header_animation-back': false,
	};

	@Output() isOpenedOptions: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() requestTarget: EventEmitter<void> = new EventEmitter<void>();

	@HostListener('scroll', ['$event'])
	tableScroll(event: Event) {
		if (!(event.target instanceof HTMLElement)) {
			return;
		}

		const tracker = event.target;
		const limit = tracker.scrollHeight - tracker.clientHeight;
		if (event.target.scrollTop < limit) {
			this.shadow = true;
		}
		if (event.target.scrollTop === limit) {
			this.shadow = false;
		}
	}

	constructor(private formService: CreateFormService, public sanitizer: DomSanitizer) {}

	get quickSelectedTeachers() {
		if (!this.formState?.data?.direction?.to) {
			return [];
		}

		const to = this.formState.data.direction.to;
		const from = this.formState.data.direction.from;

		if (!this.formState.forLater && to.request_mode === 'specific_teachers') {
			return to.request_teachers || [];
		} else if (!this.formState.forLater && to.request_mode === 'teacher_in_room') {
			if (to.request_send_destination_teachers && to.request_send_origin_teachers) {
				return [...(to.teachers || []), ...(from?.teachers ?? [])];
			} else if (to.request_send_destination_teachers) {
				return to.teachers || [];
			} else if (to.request_send_origin_teachers) {
				return from?.teachers ?? [];
			}
		} else if (this.formState.forLater && to.scheduling_request_mode === 'specific_teachers') {
			return to.scheduling_request_teachers || [];
		} else if (this.formState.forLater && to.scheduling_request_mode === 'teacher_in_room') {
			if (to.scheduling_request_send_destination_teachers && to.scheduling_request_send_origin_teachers) {
				return [...(to.teachers || []), ...(from?.teachers ?? [])];
			} else if (to.scheduling_request_send_destination_teachers) {
				return to.teachers || [];
			} else if (to.scheduling_request_send_origin_teachers) {
				return from?.teachers ?? [];
			}
		}

		return [...(to.teachers || []), ...(from?.teachers ?? [])];
	}

	get filteredTeachers() {
		return uniqBy(this.quickSelectedTeachers as User[], 'id');
	}

	ngOnInit(): void {
		this.frameMotion$ = this.formService.getFrameMotionDirection();

		this.formState = {
			step: 0,
			previousStep: 0,
			state: States.FromToWhere,
			fromState: undefined,
			formMode: {
				role: undefined,
				formFactor: undefined,
			},
			data: {
				selectedGroup: undefined,
				selectedStudents: [],
				direction: {
					from: this.pass.origin,
					to: this.pass.destination,
				},
				roomStudents: undefined,
			},
			forInput: false,
			forLater: false,
			kioskMode: false,
		};
	}

	updateTarget(target: any) {
		setTimeout(() => {
			this.requestTarget.emit(target);
		}, 100);
	}
}
